var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m3u8-video-box"},[_c('video',{ref:"videoM3U8",staticClass:"video-js",attrs:{"id":"videoM3U8","preload":"none","webkit-playsinline":"","x-webkit-airplay":"allow","playsInline":"","x5-playsinline":"","x5-video-orientation":"portraint"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }